// Configuration for the Annual Check-In frontend.
// REACT_APP_CHECKIN_API_URL can be set in .env for production deployments.
const config = {
  apiUrl: process.env.REACT_APP_CHECKIN_API_URL || 'http://localhost:8019',
};

export default config;
